import type { ShapeData } from '@/lib/shapes/types/shape-data'

/** Replaces each selected shape with the manager's fresh copy (kept as-is when the manager has none). */
export function mergeFreshShapes(shapes: ShapeData[], freshShapes: ShapeData[]): ShapeData[] {
  return shapes.map((shape) => freshShapes.find((s) => s.id === shape.id) ?? shape)
}
